'use strict';

import 'nls!./activities.json';

const activities = [
  'translation',
  'driving',
  'shopping',
  'nightlife',
  'food',
  'museums',
  'recreation',
  'culture',
  'sightseeing'
].sort();
const selectOptions = activities.map(function (activity) {
  return {
    value: activity,
    translationKey: 'ACTIVITIES.' + activity.toUpperCase()
  };
});
export default {
  options: selectOptions,
  all: selectOptions
    .reduce(function (activities, activity) {
      activities[activity.value] = activity;

      return activities;
    }, {})
};





// WEBPACK FOOTER //
// ./app/src/constants/activities.js